module.exports = __webpack_public_path__ + "media/evolve/assets/icons/animated/add-4397a2665c8a3a4f596d943b21b790c2.svg";